// Imports => Dependencies
import DashboardTabs from '@tabs/dashboard';
import ProfileTabs from '@tabs/profile';
import SettlementOverviewTabs from '@tabs/settlement-overview';
import SettlementDetailsTabs from '@tabs/settlement-details';
import TransactionOverviewTabs from '@tabs/transaction-overview';
import TransactionDetailsTabs from '@tabs/transaction-details';
import MovementDetailsTabs from '@tabs/movement-details';
import WithdrawalDetailsTabs from '@tabs/withdrawal-details';
import PurchaseOverviewTabs from '@tabs/purchase-overview';
import PurchaseDetailsTabs from '@tabs/purchase-details';

export const DASHBOARD_TABS = [
  {
    id: 'overview',
    translationKey: 'dashboard.overview',
    disabled: false,
    component: <DashboardTabs.Overview />,
    allowed: null,
  },
  {
    id: 'stats',
    translationKey: 'dashboard.stats',
    disabled: false,
    component: <DashboardTabs.Stats />,
    allowed: null,
  },
];

export const PROFILE_TABS = [
  {
    id: 'details',
    translationKey: 'profile.details',
    disabled: false,
    component: <ProfileTabs.Details />,
    allowed: null,
  },
  {
    id: 'security',
    translationKey: 'profile.security',
    disabled: false,
    component: <ProfileTabs.Security />,
    allowed: null,
  },
];

export const SETTLEMENTS_TABS = [
  {
    id: 'all',
    translationKey: 'settlements.all',
    disabled: false,
    component: <SettlementOverviewTabs.All />,
    allowed: null,
  }
];

export const SETTLEMENT_DETAILS_TABS = [
  {
    id: 'details',
    translationKey: 'settlement_details.details',
    disabled: false,
    component: <SettlementDetailsTabs.Details />,
    allowed: null,
  },
];

export const TRANSACTIONS_TABS = [
  {
    id: 'all',
    translationKey: 'transactions.all',
    disabled: false,
    component: <TransactionOverviewTabs.All />,
    allowed: null,
  },
  {
    id: 'incoming',
    translationKey: 'transactions.incoming',
    disabled: false,
    component: <TransactionOverviewTabs.Incoming />,
    allowed: null,
  },
  {
    id: 'outgoing',
    translationKey: 'transactions.outgoing',
    disabled: false,
    component: <TransactionOverviewTabs.Outgoing />,
    allowed: null,
  },
];

export const MOVEMENT_DETAILS_TABS = [
  {
    id: 'details',
    translationKey: 'transaction_details.details',
    disabled: false,
    component: <MovementDetailsTabs.Details />,
    allowed: null,
  }
];

export const WITHDRAWAL_DETAILS_TABS = [
  {
    id: 'details',
    translationKey: 'transaction_details.details',
    disabled: false,
    component: <WithdrawalDetailsTabs.Details />,
    allowed: null,
  }
];

export const TRANSACTION_DETAILS_TABS = [
  {
    id: 'details',
    translationKey: 'transaction_details.details',
    disabled: false,
    component: <TransactionDetailsTabs.Details />,
    allowed: null,
  }
];

export const PURCHASES_TABS = [
  {
    id: 'all',
    translationKey: 'purchase.all',
    disabled: false,
    component: <PurchaseOverviewTabs.All />,
    allowed: null,
  }
];

export const PURCHASE_DETAILS_TABS = [
  {
    id: 'details',
    translationKey: 'purchase_details.details',
    disabled: false,
    component: <PurchaseDetailsTabs.Details />,
    allowed: null,
  }
];

export const TABS = {
  DASHBOARD: DASHBOARD_TABS,
  PROFILE: PROFILE_TABS,
  SETTLEMENTS: SETTLEMENTS_TABS,
  SETTLEMENT_DETAILS: SETTLEMENT_DETAILS_TABS,
  TRANSACTIONS: TRANSACTIONS_TABS,
  TRANSACTION_DETAILS: TRANSACTION_DETAILS_TABS,
  MOVEMENT_DETAILS: MOVEMENT_DETAILS_TABS,
  WITHDRAWAL_DETAILS: WITHDRAWAL_DETAILS_TABS,
  PURCHASES: PURCHASES_TABS,
  PURCHASE_DETAILS: PURCHASE_DETAILS_TABS,
};

export default TABS;
